import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/Login";
import Unauthorized from "../pages/Unauthorized";
import TwoFactorAuth from "../pages/TwoFactorAuth";
import Dashboard from "../pages/Dashboard";
import Safety_Precautions from "../pages/Safety";
import Support from "../pages/Support";
import UserSettings from "../pages/UserSettings";
import Ticket from "../pages/Ticket";
import Rental from "../pages/Rental";
import CreateUsers from "../pages/CreateUsers";
import ForgetPassword from "../pages/forgot-password";
import VerifyCode from "../pages/VerifyCode";
import ScooterManagement from "../pages/scooter";
import UserStats from "../pages/UserStats";
import MySchedule from "../pages/MySchedule";
import BookAppointmentPublic from "../pages/BookAppointmentPublic";
import AppointmentList from "../pages/AppointmentList";
import SurveyList from "../pages/SurveyList";
import ConsentFormsList from "../pages/ConsentFormsList";
import { ProtectedRoute } from "../services/auth/ProtectedRoute";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/two-factor-auth" element={<TwoFactorAuth />} />
      {/* <Route path="/dashboard" element={<Dashboard />} /> */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute allowedRoles={["admin", "student employee"]}>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route path="/precautions" element={<ProtectedRoute><Safety_Precautions /></ProtectedRoute>} />
      <Route path="/support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><UserSettings /></ProtectedRoute>} />
      <Route path="/support/new" element={<ProtectedRoute><Ticket /></ProtectedRoute>} />
      <Route path="/forgot-password" element={<ForgetPassword />} />
      <Route path="/verify-code" element={<VerifyCode />} />
      <Route path="/book" element={<BookAppointmentPublic />} />
      <Route path="/rental" element={<ProtectedRoute><Rental /></ProtectedRoute>} />
      <Route path="/createusers" element={<ProtectedRoute><CreateUsers /></ProtectedRoute>} />
      <Route path="/scooterstats" element={<ProtectedRoute><ScooterManagement /></ProtectedRoute>} />
      <Route path="/userstats" element={
        <ProtectedRoute allowedRoles={["admin", "student employee"]}>
          <UserStats />
        </ProtectedRoute>
      } />
      <Route path="/schedule" element={
        <ProtectedRoute>
          <MySchedule />
        </ProtectedRoute>
      } />
      <Route path="/appointments" element={
        <ProtectedRoute allowedRoles={["admin", "student employee"]}>
          <AppointmentList />
        </ProtectedRoute>
      } />
      <Route path="/consent-forms" element={
        <ProtectedRoute allowedRoles={["admin", "student employee"]}>
          <ConsentFormsList />
        </ProtectedRoute>
      } />
      <Route path="/surveys" element={
        <ProtectedRoute allowedRoles={["admin", "student employee"]}>
          <SurveyList />
        </ProtectedRoute>
      } />
      {/* Catch-all: redirect any direct/unknown URL to unauthorized (must sign in) */}
      <Route path="*" element={<Navigate to="/unauthorized" replace />} />
    </Routes>
  );
};

export default AppRoutes;
